import React, { useState } from "react";
import Footer from "../Common/Footer";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import Nav from "../Common/Nav";
import DocumentMeta from "react-document-meta";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  useListingMyQuery,
  useListingTodayQuery,
  useListingUpcomingQuery,
} from "../../redux/userApi";
import config from "../../utils/config";
const { imageUrl } = config;

const meta = {
  title: "Listings | Green Crypto X  Exchange ",
  description:
    "Green Crypto X  Exchange Live Makes The Buying And Selling Of Crypto Coin Way More Effective And Profitable. We Are A Low Cost Cyrpto Exchange In India Like Bitcoin And Dogecoin.",
  canonical: "https://Green Crypto X  Exchange.live/buy-sell-crypto-online",
  meta: {
    charset: "utf-8",
    name: {
      keywords:
        "BTC Exchange, Crypto Trading Platform, Best Crypto Converter, Indian Crypto Exchange",
    },
  },
};

const Listing = () => {
  const [activeTab, setActiveTab] = useState("today");
  const { data: todayResponse, isLoading: isLoadingToday } =
    useListingTodayQuery();
  const { data: upcomingResponse, isLoading: isLoadingUpcoming } =
    useListingUpcomingQuery();
  const isLoggedIn = Boolean(localStorage.getItem("jwtToken"));
  const { data: myResponse, isLoading: isLoadingMy } = useListingMyQuery(
    undefined,
    { skip: !isLoggedIn }
  );

  const todayListings = todayResponse?.data || [];
  const upcomingListings = upcomingResponse?.data || [];
  const myListings = myResponse?.data || [];

  // const listHtml = () => {
  //   if (tableStatus === true) {
  //     const html = [];
  //     tableData.map(function (value, i) {
  //       const pair = value.pair;

  //       html.push(
  //         <tr>
  //           <td>{i + 1}</td>
  //           <td>{pair}</td>
  //           <td>{value.currentPrice ? value.currentPrice : 0}</td>
  //           <td>
  //             {!value.changePricePercent ? (
  //               <b className="text-danger">0%</b>
  //             ) : (
  //               ""
  //             )}
  //             {value.changePricePercent > 0 ? (
  //               <b className="text-success">{value.changePricePercent}%</b>
  //             ) : (
  //               ""
  //             )}
  //             {value.changePricePercent < 0 ? (
  //               <b className="text-danger">{value.changePricePercent}%</b>
  //             ) : (
  //               ""
  //             )}
  //           </td>
  //           <td>{value.oneDayVolume ? value.oneDayVolume : 0}</td>
  //         </tr>
  //       );
  //     });
  //     return <tbody className="main">{html}</tbody>;
  //   }
  // };

  const renderRows = (listings) => {
    if (!listings.length) {
      return (
        <tr>
          <td colSpan={6} className="text-center">
            No listings found
          </td>
        </tr>
      );
    }

    return listings.map((listing, index) => {
      const logoUrl =
        listing.logo && imageUrl ? `${imageUrl}${listing.logo}` : listing.logo;

      return (
        <tr key={listing.id || index}>
          <td>{index + 1}</td>
          <td className="d-flex align-items-center gap-2">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt={listing.short_name || listing.token_name}
                style={{ width: 24, height: 24, objectFit: "contain" }}
              />
            ) : null}
            <span>{listing.token_name}</span>
          </td>
          <td>{listing.short_name}</td>
          <td>{listing.issue_date}</td>
          <td>{listing.chain || "-"}</td>
          <td>
            {listing.website_link ? (
              <a href={listing.website_link} target="_blank" rel="noreferrer">
                Website
              </a>
            ) : (
              "-"
            )}
          </td>
        </tr>
      );
    });
  };

  const renderMyRows = (listings) => {
    if (!listings.length) {
      return (
        <tr>
          <td colSpan={7} className="text-center">
            No listings found
          </td>
        </tr>
      );
    }

    return listings.map((listing, index) => {
      const logoUrl =
        listing.logo && imageUrl ? `${imageUrl}${listing.logo}` : listing.logo;
      const statusClass =
        listing.status === "approved"
          ? "success"
          : listing.status === "rejected"
          ? "danger"
          : "warning";
      return (
        <tr key={listing.id || index}>
          <td>{index + 1}</td>
          <td className="d-flex align-items-center gap-2">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt={listing.short_name || listing.token_name}
                style={{ width: 24, height: 24, objectFit: "contain" }}
              />
            ) : null}
            <span>{listing.token_name}</span>
          </td>
          <td>{listing.short_name}</td>
          <td>{listing.issue_date}</td>
          <td>{listing.chain || "-"}</td>
          <td>
            <span className={`badge bg-${statusClass}`}>
              {listing.status}
            </span>
          </td>
          <td>
            {listing.website_link ? (
              <a href={listing.website_link} target="_blank" rel="noreferrer">
                Website
              </a>
            ) : (
              "-"
            )}
          </td>
        </tr>
      );
    });
  };

  const checkLogin = () => {
    if (!localStorage.getItem("jwtToken")) {
      toast.dismiss();
      toast.error("Please login to apply");
      return false;
    } else {
      toast.dismiss();
      window.location.href = "/applyListing";
    }
  };

  return (
    <div>
      {" "}
      <DocumentMeta {...meta}>
        <Nav graphColor="" />
        {/* <MainHeader /> */}

        <header className="home position-relative launch-home" id="home">
          <div className="container">
            <div className="home-outer launchpaid-outer launchpaid-off">
              <div className="banner-left">
                <h1>LISTING</h1>
                <h2>
                  Looking to get your crypto project noticed? Our exchange is
                  the perfect platform to showcase your digital assets and reach
                  a wider audience.
                </h2>
                <p>
                  With our robust security measures and user-friendly interface,
                  you can list your crypto with confidence. Gain exposure to our
                  growing community of crypto enthusiasts and investors hungry
                  for the next big thing.
                </p>

                <div className="banner-btn-outer">
                  {/* <a href='javascript:void(0)' className='btn btn-primary'>Trade Now</a> */}

                  <button className="btn btn_man" onClick={checkLogin}>
                    Apply for Listing
                  </button>
                </div>
              </div>
              <div className="banner-right">
                <img
                  src="assets/img/listing-right.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </header>

        <div className="listing-main listing-fullwidtdh">
          <div className="container">
            <div className="listing-outer">
              <div className="listing-tabs">
                <button
                  className={`listing-tab-btn ${
                    activeTab === "today" ? "active" : ""
                  }`}
                  type="button"
                  onClick={() => setActiveTab("today")}
                >
                  Today Listings
                </button>
                <button
                  className={`listing-tab-btn ${
                    activeTab === "upcoming" ? "active" : ""
                  }`}
                  type="button"
                  onClick={() => setActiveTab("upcoming")}
                >
                  Upcoming Listings
                </button>
                {isLoggedIn ? (
                  <button
                    className={`listing-tab-btn ${
                      activeTab === "my" ? "active" : ""
                    }`}
                    type="button"
                    onClick={() => setActiveTab("my")}
                  >
                    My Listings
                  </button>
                ) : null}
              </div>

              <div className="listing-table">
                {activeTab === "today" ? (
                  <>
                    {isLoadingToday ? (
                      <p className="text-white mb-0">Loading...</p>
                    ) : (
                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Name</th>
                            <th>Symbol</th>
                            <th>Issue Date</th>
                            <th>Chain</th>
                            <th>Website</th>
                          </tr>
                        </thead>
                        <tbody className="main">
                          {renderRows(todayListings)}
                        </tbody>
                      </table>
                    )}
                  </>
                ) : activeTab === "upcoming" ? (
                  <>
                    {isLoadingUpcoming ? (
                      <p className="text-white mb-0">Loading...</p>
                    ) : (
                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Name</th>
                            <th>Symbol</th>
                            <th>Issue Date</th>
                            <th>Chain</th>
                            <th>Website</th>
                          </tr>
                        </thead>
                        <tbody className="main">
                          {renderRows(upcomingListings)}
                        </tbody>
                      </table>
                    )}
                  </>
                ) : (
                  <>
                    {isLoadingMy ? (
                      <p className="text-white mb-0">Loading...</p>
                    ) : (
                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Name</th>
                            <th>Symbol</th>
                            <th>Issue Date</th>
                            <th>Chain</th>
                            <th>Status</th>
                            <th>Website</th>
                          </tr>
                        </thead>
                        <tbody className="main">
                          {renderMyRows(myListings)}
                        </tbody>
                      </table>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <Footer />
        <ToastContainer />
      </DocumentMeta>
    </div>
  );
};
export default Listing;
